import api from '@/api/config'

export async function readChat (key, messages = false) {
  const result = await api.post('/api/member-read/' + key, { collection: 'chat', id: key, messages })
  const docs = result.data.documents.map(doc => ({ id: doc.id, exists: true, data: () => doc.data }))
  return messages ? { docs } : docs[0] || { exists: false, data: () => undefined }
}

export function watchChat (key, messages, callback) {
  let cancelled = false
  let timer
  const poll = async () => {
    try {
      const result = await readChat(key, messages)
      if (!cancelled) callback(result)
    } catch (_) {
      // Retry after transient connection/session errors without logging credentials.
    }
    if (!cancelled) timer = window.setTimeout(poll, 5000)
  }
  poll()
  return () => { cancelled = true; window.clearTimeout(timer) }
}
